import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  CBreadcrumbRouter,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderNavItem,
  CHeaderNavLink,
  CSubheader,
  CToggler,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import routes from "../routes";
import { storeUserInterfaceInfo } from "src/actions/uiAction";

const TheHeader = () => {
  const dispatch = useDispatch();
  const { sidebar, asideShow, darkMode, showSideBar } = useSelector(
    (state) => state.ui
  );
  const toggleSidebar = () => {
    const val = [true, "responsive"].includes(sidebar) ? false : "responsive";
    dispatch(storeUserInterfaceInfo({ sidebar: val }));
  };

  const toggleSidebarMobile = () => {
    const val = [false, "responsive"].includes(sidebar) ? true : "responsive";
    dispatch(storeUserInterfaceInfo({ sidebar: val }));
  };
  return (
    <CHeader withSubheader>
      <CToggler
        inHeader
        className="ml-md-3 d-lg-none"
        onClick={toggleSidebarMobile}
      />
      <CToggler
        inHeader
        className="d-md-down-none bg-danger text-white rounded-0"
        onClick={toggleSidebar}
      />
      <CHeaderBrand className="mx-auto d-lg-none" to="/">
        {/* <CIcon name="logo" height="48" alt="Logo"/> */}
        <h1>OVR</h1>
      </CHeaderBrand>

      <CHeaderNav className="d-md-down-none mr-auto">
        <CHeaderNavItem className="px-3">
          {/* <CHeaderNavLink to="/dashboard">Dashboard</CHeaderNavLink> */}
        </CHeaderNavItem>
      </CHeaderNav>

      <CHeaderNav className="px-3">
        <CHeaderNavItem>
          <CHeaderNavLink to="/logout">Logout</CHeaderNavLink>
        </CHeaderNavItem>
        {/*<CToggler*/}
        {/*  inHeader*/}
        {/*  className="ml-3 d-md-down-none c-d-legacy-none"*/}
        {/*  onClick={() => dispatch({type: 'set', darkMode: !darkMode})}*/}
        {/*  title="Toggle Light/Dark Mode"*/}
        {/*>*/}
        {/*  <CIcon name="cil-moon" className="c-d-dark-none" alt="CoreUI Icons Moon" />*/}
        {/*  <CIcon name="cil-sun" className="c-d-default-none" alt="CoreUI Icons Sun" />*/}
        {/*</CToggler>*/}
        {/*<CToggler*/}
        {/*  inHeader*/}
        {/*  className="d-md-down-none"*/}
        {/*  onClick={() => dispatch({type: 'set', asideShow: !asideShow})}*/}
        {/*>*/}
        {/*  <CIcon className="mr-2" size="lg" name="cil-applications-settings" />*/}
        {/*</CToggler>*/}
      </CHeaderNav>

      <CSubheader className="px-3 justify-content-between">
        <CBreadcrumbRouter
          className="border-0 c-subheader-nav m-0 px-0 px-md-3"
          routes={routes}
        />
      </CSubheader>
    </CHeader>
  );
};

export default TheHeader;
